<template>
  <div class="container-fluid">
    <div class="container">
      <ResetEntry :token=this.token />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  metaInfo: {
    title: 'Przypomnij hasło',
  },
  props: {
    token: {
      type: String
    }
  },
  components: {
    'ResetEntry': () => import('@/pages/components/ResetEntry')
  },

}
</script>
